/**
 * Storage keys for the appearance preference, kept free of React (and of any
 * other import) so `vite.config.ts` can read them when it generates the
 * pre-paint script without pulling the app bundle into the config.
 */
export const THEME_STORAGE_KEY = "qcs-theme";

/** Settings that no longer exist; the pre-paint script clears them on the way past. */
export const RETIRED_APPEARANCE_KEYS = ["qcs-accent"] as const;
